module.exports = __webpack_public_path__ + "img/bluesky3100_28.d7818037.jpg";